import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterAsc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFilterAsc"><Path fillRule="evenodd" clipRule="evenodd" d="M18 3.58569L22.4142 7.99991L21 9.41412L19 7.41412V13.9999H17V7.41412L15 9.41412L13.5858 7.99991L18 3.58569ZM3 4.99991H10V6.99991H3V4.99991ZM3 10.9999H12V12.9999H3V10.9999ZM3 16.9999H19V18.9999H3V16.9999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilterAsc;
